import mainLoadingVue from './MainloadingServe.vue'

const MainLoading = {};

/*
Mainloading 调试入口说明

1. 所有审核 debug 开关统一从这里进入
2. 本地调试时，直接改下面这个常量：`AUDIT_DEBUG_SCENARIO`
3. 例如：
   `const AUDIT_DEBUG_SCENARIO = 'rejected'`
   `const AUDIT_DEBUG_SCENARIO = 'failed'`
   `const AUDIT_DEBUG_SCENARIO = 'poll_job_not_found'`
4. 置空字符串 `''` 即恢复真实请求
5. 是否真正启用 mock，仍由组件内部按 `ISDEBUG = 1` 决定
6. debug 下真实 createJob / getJob 请求仍会发出，你可以在 Network 里看到
7. debug 不再 merge 真实响应和 mock 响应，页面只吃场景脚本返回
8. 真实响应当前只用于确保请求真的发出，并沿用真实 create 返回的 jobId 去轮询
*/
const AUDIT_DEBUG_SCENARIO = '';

MainLoading.install = function(Vue) {
	const MainLoadingInstance = Vue.extend(mainLoadingVue);
	let currentMainLoading;
	const initInstance = () => {
		currentMainLoading = new MainLoadingInstance();
		let MainLoadingEl = currentMainLoading.$mount().$el;
		document.body.appendChild(MainLoadingEl);
	}

	Vue.prototype.$mainloading = {
		load (options) {
			if (!currentMainLoading) {
				initInstance();
			}
			const runtimeOptions = Object.assign({}, options || {});
			if (!runtimeOptions.auditDebugScenario) {
				runtimeOptions.auditDebugScenario = AUDIT_DEBUG_SCENARIO;
			}

			currentMainLoading.options = Object.assign({}, currentMainLoading.options || {}, runtimeOptions);

			return currentMainLoading.load();
		},
		show () {
			return currentMainLoading.show();
		},
		hide () {
			return currentMainLoading.hide();
		}
	}
}

export default MainLoading
